module.exports = [["yes","Ja"],["no","Nein"]]


//////////////////
// WEBPACK FOOTER
// ./src/pages/Helpers/Storage/Castrated.json
// module id = 227
// module chunks = 0